import { render, staticRenderFns } from "./RemoteData.vue?vue&type=template&id=13652204&scoped=true&"
import script from "./RemoteData.vue?vue&type=script&lang=js&"
export * from "./RemoteData.vue?vue&type=script&lang=js&"
import style0 from "./RemoteData.vue?vue&type=style&index=0&id=13652204&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13652204",
  null
  
)

export default component.exports